import progressButton from '../../app/routing/WicketRouteRenderer/legacyScripts/progressButton';

progressButton(document.body);
